module.exports = __webpack_public_path__ + "img/icon_historial.a5462198.svg";